import { AptunoButton, Icon, SIZES, VARIANTS } from '@aptuno/aptuno-ui';
import { ApplicationStateSteps, estateApplicationStageContext } from '@contexts/Estate';
import { useRouter } from 'next/router';
import React, { useContext } from 'react';

import { ActionsBarRoot, Blue, HeaderButton, ListItem, TextBox, TitleSection } from '../EstateApplication.styled';
import { ApplicationDocumentCheckWrapper } from './ApplicationDocumentsCheck.styled';

const DocumentsCheckList = [
  'Fotos de tu documento de identidad por ambos lados',
  'Extractos bancarios de los últimos tres meses',
  'Soportes para validar tus ingresos, según tu situación laboral',
  'Si declaras renta, necesitamos tu última declaración presentada',
];
const ApplicationDocumentsCheck = () => {
  const estateApplication = useContext(estateApplicationStageContext);

  // todo: validate business logic here
  const router = useRouter();

  const isCotenant = !!router.query?.applicationId;

  const handleNextStepClick = () => {
    if (isCotenant) estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.basicInformation);
    else estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.tenantDisclaimer);
  };

  const handleOnBackClick = () => {
    if (isCotenant) estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.addCotenant);
    else estateApplication && estateApplication.setCurrentState(ApplicationStateSteps.onboarding);
  };

  return (
    <ApplicationDocumentCheckWrapper>
      <HeaderButton appearance={VARIANTS.SECONDARY} isCircular onClick={handleOnBackClick}>
        <Icon icon="arrowleftalt" />
      </HeaderButton>
      <TitleSection>
        Necesitaremos estos
        <Blue>documentos:</Blue>
      </TitleSection>
      <TextBox>
        {DocumentsCheckList.map((item, index) => (
          <ListItem key={`documents-checklist-${index}`} iconColor="black">
            <div>
              <Icon width={'20px'} height={'20px'} icon="gear-check" />
            </div>
            {item}
          </ListItem>
        ))}
      </TextBox>
      <ActionsBarRoot>
        <AptunoButton appearance={VARIANTS.PRIMARY} size={SIZES.BIGGEST} onClick={handleNextStepClick}>
          Siguiente
          <Icon width={'12px'} height={'12px'} icon="Arrow_Right" />
        </AptunoButton>
      </ActionsBarRoot>
    </ApplicationDocumentCheckWrapper>
  );
};

export { ApplicationDocumentsCheck };
